<template>
  <div class="order-container">
    <el-card>
      <div slot="header">
        <span>订单查询</span>
      </div>

      <!-- 搜索区域 -->
      <div class="search-box" style="margin-bottom: 20px;">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" @submit.native.prevent>
          <el-form-item label="用户ID">
            <el-input 
              v-model="searchForm.userId" 
              placeholder="请输入用户ID" 
              clearable
              style="width: 200px;"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search" @keyup.enter="handleSearch">搜索</el-button>
            <el-button @click="handleReset" icon="el-icon-refresh-left">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 用户表格 -->
      <el-table :data="tableData" v-loading="loading" style="width: 100%" border>
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="userid" label="用户ID"></el-table-column>
        <el-table-column prop="coptype" label="类型"></el-table-column>
        <el-table-column prop="cmemo" label="备注"></el-table-column>
        <el-table-column prop="dsum" label="金额" sortable></el-table-column>
        <el-table-column prop="trade_no" label="订单号"></el-table-column>
        <el-table-column prop="ddate" label="时间" sortable></el-table-column>
      </el-table>

      <!-- 分页（可选） -->
      <div class="pagination" style="margin-top: 20px; text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="prev, pager, next, total, sizes"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'Orders',
  data() {
    return {
      loading: false,
      tableData: [],
      // 分页相关（暂不启用）
      page: 1,
      pageSize: 10,
      total: 0,
            // 表单验证规则
      searchRules: {
        userId: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
          { pattern: /^\d+$/, message: '用户ID必须为数字', trigger: 'blur' }
        ]
      },

      // 搜索表单
      searchForm: {
        userId: ''
      }
    }
  },
  filters: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  },
  created() {},
  methods: {

    async fetchOrderList() {
      if (!this.searchForm.userId) {
        this.$message.warning('请输入用户ID');
        return;
      }
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          userId: this.searchForm.userId || undefined,
        };
        const {data: res}= await this.$http.get('get_order_list', {params});
        this.tableData = res.data
        this.total = res.total
      } catch (error) {
        this.$message.error('获取订单列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    // 搜索
    async handleSearch() {
      const valid = await this.$refs.searchForm.validate().catch(() => false);
      if (!valid) {
        this.$message.warning('请输入用户ID');
        return;
      }
      this.page = 1; // 搜索时重置到第一页
      this.fetchOrderList();
    },

    // 重置搜索条件
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        userId: ''
      };
      this.page = 1;
    },


    filterTag(value, row) {
      return row.verify === value;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.fetchOrderList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchOrderList();
    }
  }
}
</script>

<style lang="less">
.order-container {
  padding: 20px;
}

.password_show {
  .el-input__inner {
    border: none;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>